module.exports = __webpack_public_path__ + "img/Banner-FamilyInLivingRoom-dwnszd.3564f879.jpg";